import React from "react";

export const IconWarn: React.FC<{ size?: number }> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path
      d="M32 6l27 47a4 4 0 0 1-3.5 6H8.5A4 4 0 0 1 5 53L32 6z"
      fill="#F59E0B"
    />
    <rect x="29" y="22" width="6" height="18" rx="3" fill="#fff" />
    <circle cx="32" cy="46" r="3" fill="#fff" />
  </svg>
);
export const IconStop: React.FC<{ size?: number }> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill="#EF4444" />
    <circle cx="32" cy="32" r="24" fill="#fff" />
    <path
      d="M21 21l22 22M43 21L21 43"
      stroke="#EF4444"
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);
export const IconShieldGray: React.FC<{ size?: number }> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path
      d="M32 6l22 8v15c0 14.5-9.2 22.8-22 29-12.8-6.2-22-14.5-22-29V14l22-8z"
      fill="#9CA3AF"
    />
  </svg>
);
export const IconShield: React.FC<{ size?: number }> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
    <path
      d="M32 6l22 8v15c0 14.5-9.2 22.8-22 29-12.8-6.2-22-14.5-22-29V14l22-8z"
      fill="#22C55E"
    />
    <path
      d="M22 33l6 6 14-14"
      stroke="#fff"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Close: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
